
export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Discover',
      description: 'We dive deep into your vision, goals, and challenges. Understanding your needs is where great work begins.',
      icon: 'ri-search-eye-line',
      color: 'bg-[#D96B33]'
    },
    {
      number: '02',
      title: 'Proposal',
      description: 'Based on our discovery phase, we create a detailed proposal outlining the project scope, timeline, and investment required.',
      icon: 'ri-file-text-line',
      color: 'bg-[#AFC4E4]'
    },
    {
      number: '03',
      title: 'Design',
      description: 'Wireframes, prototypes, and visual concepts come to life. We craft experiences that look stunning and work flawlessly.',
      icon: 'ri-pencil-ruler-2-line',
      color: 'bg-[#2E3F25]'
    },
    {
      number: '04',
      title: 'Build',
      description: 'Code meets creativity. Our developers transform designs into robust, scalable, and high-performance solutions.',
      icon: 'ri-code-box-line',
      color: 'bg-[#D96B33]'
    },
    {
      number: '05',
      title: 'Test',
      description: 'Rigorous QA ensures everything works perfectly. We catch issues before they become problems.',
      icon: 'ri-bug-line',
      color: 'bg-[#AFC4E4]'
    },
    {
      number: '06',
      title: 'Launch',
      description: 'Deployment day! We launch your project and provide ongoing support to ensure continued success.',
      icon: 'ri-rocket-line',
      color: 'bg-[#2E3F25]'
    }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-[#EBEBE0] to-[#182114]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-[#182114] mb-6" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
            How We <span className="text-[#D96B33]">Work</span>
          </h2>
          <div className="w-24 h-1 bg-[#D96B33] mx-auto mb-8"></div>
          <p className="text-xl text-[#2E3F25] max-w-3xl mx-auto" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
            Our proven process takes you from idea to launch with clarity, collaboration, and creativity at every step.
          </p>
        </div>

        <div className="relative mt-20">
          {/* Connection line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-[#D96B33] via-[#AFC4E4] to-[#D96B33]"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                {/* Step card */}
                <div className="group bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-4 cursor-pointer">
                  {/* Number badge */}
                  <div className={`absolute -top-6 left-8 w-16 h-16 ${step.color} rounded-2xl flex items-center justify-center text-white text-2xl font-bold shadow-lg group-hover:scale-110 transition-transform duration-300`} style={{ fontFamily: '"Distro Bold", sans-serif' }}>
                    {step.number}
                  </div>

                  {/* Icon */}
                  <div className="mt-8 mb-6">
                    <div className={`w-16 h-16 ${step.color}/10 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                      <i className={`${step.icon} text-3xl`} style={{ color: step.color.replace('bg-', '') === '[#D96B33]' ? '#D96B33' : step.color.replace('bg-', '') === '[#AFC4E4]' ? '#AFC4E4' : '#2E3F25' }}></i>
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-bold text-[#182114] mb-4" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
                    {step.title}
                  </h3>
                  
                  <p className="text-[#2E3F25] leading-relaxed" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
                    {step.description}
                  </p>
                </div>

                {/* Arrow connector for mobile */}
                {index < steps.length - 1 && (
                  <div className="lg:hidden flex justify-center my-4">
                    <i className="ri-arrow-down-line text-3xl text-[#D96B33]"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-20">
          <p className="text-2xl text-white font-semibold mb-6" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
            Ready to start your journey?
          </p>
          <button
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center gap-3 bg-[#D96B33] text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-[#D96B33]/90 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-[#D96B33]/50 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: '"Century Gothic", sans-serif' }}
          >
            Let's Get Started
            <i className="ri-arrow-right-line text-2xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}